/**
 * Note: This file is autogenerated using "resources/gen-version.js" script and
 * automatically updated by "npm version" command.
 */

/**
 * A string containing the version of the GraphQL.js library
 */
export var version = '15.5.3';
/**
 * An object containing the components of the GraphQL.js version string
 */

export var versionInfo = Object.freeze({
  major: 15,
  minor: 5,
  patch: 3,
  preReleaseTag: null
});



//////////////////
// WEBPACK FOOTER
// ./~/graphql/version.mjs
// module id = xBfQ
// module chunks = 9